import { Dialog } from 'components/dialog';
import { HeadingAddon } from './components/heading-addon';
import { Loading } from './components/loading/loading';
import { Error } from 'components/error';
import { DraftDialogFooter } from './components/draft-dialog-footer';
import { DraftsList } from './components/drafts-list';
import { IDraftDialog } from './types';
import { styles } from './styles';

export const DraftDialog = ({ open, data, isError, isLoading, onClose }: IDraftDialog) => {
  const renderContent = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (isError) {
      return <Error sx={styles.error} />;
    }

    return <DraftsList drafts={data.items} onClose={onClose} />;
  };

  return (
    <Dialog sx={styles.dialog} open={open} onClose={onClose}>
      <Dialog.Header
        heading="Draft Posts"
        headingAddon={!!data?.items.length && <HeadingAddon>{data?.items.length}</HeadingAddon>}
      />
      <Dialog.Content sx={styles.dialogContent}>{renderContent()}</Dialog.Content>
      <Dialog.Footer>
        <DraftDialogFooter onCancel={onClose} />
      </Dialog.Footer>
    </Dialog>
  );
};
